<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "OutputBrands" });
import Chiplist from "../../../../elements/chip-list/ChipList.svelte";
import BrandList from "../../modules/list/BrandList.svelte";
import BrandItem from "../../modules/item/BrandItem.svelte";
export let keys = [];
export let verticalCodes = [];
export let maxItems = void 0;
export let auctionKey = void 0;
export let subscriptionKey = void 0;
export let color = "neutral";
$: parameters = { auctionKey, limit: 5e3, states: ["created", "approved"], subscriptionKey, verticalCodes };
const format = (brands) => brands.filter(({ _ }) => keys.includes(_.key)).map(({ name }) => ({ label: name }));
</script>

{#if Array.isArray(keys) && keys.length > 1 }
    <BrandList { parameters } let:brands>
        <!-- TODO: Upgrade Svelte & Fix Typing on Slots  -->
        <!-- eslint-disable-next-line @typescript-eslint/no-unsafe-argument -->
        <Chiplist items = { format(brands) } { color } { maxItems }/>
    </BrandList>
{:else if Array.isArray(keys) && keys.length === 1}
    <BrandItem key = { keys[0] } let:brand>
        <!-- eslint-disable-next-line @typescript-eslint/no-unsafe-argument -->
        <Chiplist items = { format([ brand ]) } { color } { maxItems }/>
    </BrandItem>
{/if}